import { Modal } from 'antd'
import React from 'react'

import { FileDisplay } from '@/components'
import { LocalFileFragment } from '@/generated/graphql'

export const AnnouncementVideoModal: React.FC<{ files: LocalFileFragment[]; visible: boolean; toggle: () => void }> = ({
  files,
  visible,
  toggle,
}) => {
  return (
    <Modal width={1000} visible={visible} footer={null} closable={true} maskClosable={true} onCancel={() => toggle()}>
      {files.map((file) => (
        <FileDisplay key={file.fileId} width='100%' height='auto' file={file} autoplay={true}></FileDisplay>
      ))}
    </Modal>
  )
}
